import { NewPatient } from "cadendar-shared";
import { BRAND } from "zod/v4";

export const getBlankPatient = () => {
  const newPatient = {
    name: "",
    forename: "",
    birthdate: "01/01/2001" as string & BRAND<"DDN">,
    portablee164: null,
    email: "",
    email_consent: null,
    sms_consent: null,
    comments: "",
    patient_flags: null,
    famille_id: null,
    adr_flag: null,
    adr_id: null,
    raf: null,
    seen: null,
    former_patient: false,
    adr_other_text: null,
    genre: null,
    logos_file_number: null,
    address: null,
    address_complement: null,
    city: null,
    postal_code: null,
    insee_number: null,
    familly_rank: null,
    maiden_name: null,
  } satisfies NewPatient;
  return newPatient;
};
